import React from 'react';
import '../TermsAndConditions/TermsAndConditions.css';

const PrivacyPolicy = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <header className="terms-header">
          <h1>Privacy Policy</h1>
          <p>How we protect your information and data</p>
        </header>

        <div className="terms-body">
          <p>
            At Tripmart we take extra care in protecting your privacy and the data you submit to us when booking with any of our trading divisions. Information We May Collect About You When using this web site, we may ask you for some personal information. You are free to decide as to whether you will give this information to us. Some services that we offer may not be available if you do not supply the information requested. We may request personal information in the following circumstances.
          </p>

          <div className="terms-section">
            <h2>When you:</h2>
            
            <div className="booking-section">
              <ol>
                <li>Purchase or reserve a product with us.</li>
                <li>Submit a product enquiry to us.</li>
                <li>Provide us with feedback about our web site.</li>
                <li>Request a brochure from us.</li>
                <li>Register to receive emails about our products and special offers.</li>
                <li>Take part in one of our online surveys.</li>
                <li>Apply for a job.</li>
              </ol>
            </div>

            <div className="terms-subsection">
              <h3>Product And Special Offer Emails</h3>
              <p>
                If you register to receive product emails from us then we will hold your email address and send you information regarding our products. You may choose to opt out of our mailing list at any time by using the un-subscribe link in the emails you receive.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Computer Information</h3>
              <p>
                We may collect technical information about your computer when you visit our web site. This may include your IP address, operating system, web browser software, screen resolution and referring web site. We do not link any of this computer information to any personal information we hold about you. This information is used purely to ensure our web site is built to provide the best experience for you.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>How We Use This Information</h3>
              <h4>To Fulfil Booking Requests</h4>
              <p>
                When you book or reserve a product with us we will hold the information you submit to process, administer and account for your booking. You should expect to receive an email confirmation from us shortly after you complete your booking or reservation. In addition, we may call you if necessary to fulfil the service offered to you.
              </p>
              <p>
                The information you provide may be passed to third parties as necessary to provide the services requested. These third parties may be located outside of the UK.
              </p>
              
              <h4>Product Enquiries</h4>
              <p>
                If you submit a product enquiry to us using one of the forms on the web site, we will use this information to produce a quotation for you. You can expect to receive and email or a phone call as a follow up to a product enquiry.
              </p>
              
              <h4>Feedback And Surveys</h4>
              <p>
                If you submit feedback to us regarding our services, then we will use the information submitted to improve our services. We may contact you by email or phone to discuss any feedback that you provide.
              </p>
              <p>
                If you volunteer to take part in a survey on our web site, then any information collected will only be used for statistical purposes. You personal information will not be identifiable from the results of any survey.
              </p>
              
              <h4>Product And Special Offer Emails</h4>
              <p>
                If you register to receive product emails from us you can expect to receive emails regarding all of our travel services and products. The details you submit to receive this information is not used for any other purpose and will not be shared with any third parties.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Is Your Information Secure</h3>
              <p>
                We take great care in ensuring that any personal information you submit is secure and held securely. The information you submit will only be used for the purposes described in this privacy policy.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Other Web Sites</h3>
              <p>
                We provide links to related web sites throughout our web site. These are placed here for your convenience. You should be aware that the content or information provided on these third party web site is not the responsibility of Tripmart Limited and is not covered by this privacy policy.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Job Applications</h3>
              <p>
                Any information you send in response to a job advertisement is used solely for recruitment purposes. We may contact you by phone or email in relation to any job applications you make. The personal information you submit will not be used for any other purposes.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Can We Change This Policy?</h3>
              <p>
                The Tripmart Limited reserves the right to change and amend this policy for any reason. The policy which was in place at the time you submitted information to us will apply.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Feedback, Comments And Suggestions</h3>
              <p>
                Tripmart Limited welcomes your questions and comments about privacy, as well as any other aspect of our service.
              </p>
              <p>
                If you would like to contact tripmart.co.uk regarding this policy, then please send you enquiry by email to info@tripmart.co.uk.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;